import React from 'react';
import CardsList from './components/CardsList/CardsList';

const HomePage = () => {
    return <CardsList />;
};

export default HomePage;
